export default __webpack_public_path__ + "static/media/img_muslinTwoEars_yg_p.0bd10259.jpg";